/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const newProductCardDisplaySchema = z.object({
	product_card_display_fit_type: z.string().nullable(),
	product_card_display_height_type: z.any(),
	price_tag_config: z.any(),
});
